/**
 * Labels shared between the sidebar, the header and the details panel.
 * Split out of the old mock data module so nothing here is mock.
 */
export const TAB_DEFINITIONS = [
  { id: 'all', label: 'All' },
  { id: 'unread', label: 'Unread' },
  { id: 'read', label: 'Read' },
];

export const DETAIL_TABS = [
  { id: 'orders', label: 'My Orders' },
  { id: 'profile', label: 'User Profile' },
];

export const INBOX_LABELS = {
  buyer: 'Buying inbox',
  seller: 'Selling inbox',
};

export const SOCKET_STATUS_LABELS = {
  idle: 'Connecting…',
  connecting: 'Connecting…',
  open: 'Live',
  closed: 'Reconnecting…',
};
